import { hasPermission } from "Common/permissions";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import api from "Common/api";
export function LeadContractAction({ leadId }: { leadId: string | number }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const [existingProjectId, setExistingProjectId] = useState<number | null | undefined>(undefined);
  let role = "";
  try { role = jwtDecode<{ userType?: string }>(localStorage.getItem("authUser") || "").userType || ""; } catch {}
  const canCreateContract = ["contractor", "testContractor"].includes(role) && hasPermission("CREATE_CONTRACT");
  useEffect(() => {
    let active = true;
    if (!canCreateContract) {
      setExistingProjectId(null);
      return () => { active = false; };
    }
    api.get<{ existingProjectId: number | null }, { existingProjectId: number | null }>(`/contract/from-lead/${leadId}`)
      .then(result => { if (active) setExistingProjectId(result.existingProjectId); })
      .catch(() => { if (active) setExistingProjectId(null); });
    return () => { active = false; };
  }, [canCreateContract, leadId]);
  if (!canCreateContract) return null;
  const open = async () => {
    if (busy) return;
    setBusy(true); setError(false);
    try {
      const result = await api.get<{ existingProjectId: number | null }, { existingProjectId: number | null }>(`/contract/from-lead/${leadId}`);
      navigate(result.existingProjectId ? `/create-contract?tab=Project-Details&id=${result.existingProjectId}` : `/create-contract?type=project&sourceJobId=${leadId}`);
    } catch { setError(true); } finally { setBusy(false); }
  };
  if (existingProjectId !== undefined && existingProjectId !== null) {
    return <span onClick={event => event.stopPropagation()}><button type="button" className="btn btn-sm btn-outline-primary" onClick={() => navigate(`/create-contract?tab=Project-Details&id=${existingProjectId}`)}>View Contract</button></span>;
  }
  if (existingProjectId === undefined) {
    return <span onClick={event => event.stopPropagation()}><button type="button" className="btn btn-sm btn-outline-primary" disabled>Checking contract…</button></span>;
  }
  return <span onClick={event => event.stopPropagation()}><button type="button" className="btn btn-sm btn-outline-primary" disabled={busy} onClick={open}>{busy ? "Opening…" : "Create Contract"}</button>{error && <span role="alert" className="d-block text-danger small">Unable to open contract. Please try again.</span>}</span>;
}
